export class RisExamItemsDto {
  CategoryId?: number;
  ExamconsumablesId?: number;
  ItemId?: number;
  ItemName?: string;
  Quantity?: number;
  DisplayOrder?: number;
}
